import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class PublicWebContentService {
  /**
   * Get all content for a specific page
   */
  static async getPageContent(page) {
    try {
      const response = await axios.get(`${API_BASE_URL}/public-web/page/${page}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching page content for ${page}:`, error);
      throw error;
    }
  }
}

export default PublicWebContentService;
